import { FC } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootReducer, StreamingReducer } from '../../../../../../models/Redux';
import { ViewerState } from '../../../../../../models/StreamingState';
import ViewerWaitingDialogItem from '../ViewerWaitingDialogItem';

interface QueueDialogProps {
    open: boolean;
    onDismiss: () => void;
}

const QueueDialog: FC<QueueDialogProps> = ({ open, onDismiss }) => {
    const { t } = useTranslation();
    const {
        streamingState: {
            // @ts-ignore
            current_state: { raised_hands: raiseHandQueue, viewers },
        },
    } = useSelector<RootReducer, StreamingReducer>(state => state.streaming);

    return (
        <Dialog open={open} onClose={onDismiss} maxWidth="lg" fullWidth>
            <DialogTitle>{t("Select viewer's turn")}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Grid
                        container
                        xs={12}
                        justify="space-between"
                        alignContent="center"
                        alignItems="center"
                        direction="row"
                    >
                        {viewers
                            .filter((viewer: ViewerState) =>
                                raiseHandQueue.find(
                                    (vWaiting: ViewerState) => vWaiting.username === viewer.username,
                                ),
                            )
                            .map((viewerWaiting: ViewerState, index: number) => {
                                return (
                                    <ViewerWaitingDialogItem
                                        key={index}
                                        avatar={viewerWaiting.user_avatar}
                                        username={viewerWaiting.username}
                                    />
                                );
                            })}
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onDismiss} autoFocus>
                    <Typography>{t('Close')}</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default QueueDialog;
